import type { QuantityKind } from "../utils/formatQuantityValue";

// Reuses the review page's own tab labels so the comparison can't drift from them.
export const KIND_LABEL_KEY: Record<QuantityKind, string> = {
  elements: "smartSurveyor.reviewPage.tabs.floorPlanElements",
  cables: "smartSurveyor.reviewPage.tabs.cableGroups",
};

export const TYPE_LABEL_KEY: Record<QuantityKind, string> = {
  elements: "smartSurveyor.planComparison.quantities.elementTypes",
  cables: "smartSurveyor.planComparison.quantities.trayTypes",
};

// Numeric columns shrink first so long type names keep usable width on narrow screens.
export const QUANTITY_GRID_CLASS =
  "grid grid-cols-[minmax(0,1fr)_4rem_4rem_4.5rem] items-center gap-2 sm:grid-cols-[minmax(0,1fr)_6rem_6rem_6rem] sm:gap-3";

// Fixed height so section headers can pin exactly below, and a higher layer so they never cover it.
export const COLUMN_HEADER_STICKY_CLASS = "sticky top-0 z-20 h-7 bg-white";

export const SECTION_HEADER_STICKY_CLASS = "sticky top-7 z-10 bg-white";
